import React, {useEffect, useState} from 'react';
import {DatePicker, Form, Input, Modal} from 'antd';
import {updateProject} from '../api/projectApi';
import dayjs from 'dayjs';

const { TextArea } = Input;

const ProjectEditModal = ({ open, project, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  // 프로젝트 데이터로 폼 초기화
  useEffect(() => {
    if (open && project) {
      form.setFieldsValue({
        pjtNo: project.pjtNo,
        pjtNm: project.pjtNm,
        pjtPicNm: project.pjtPicNm,
        pjtBgngYmd: project.pjtBgngYmd ? dayjs(project.pjtBgngYmd, 'YYYY-MM-DD') : null,
        pjtEndYmd: project.pjtEndYmd ? dayjs(project.pjtEndYmd, 'YYYY-MM-DD') : null,
        pjtOpnDt: project.pjtOpnDt ? dayjs(project.pjtOpnDt) : null,
        pjtInfo: project.pjtInfo,
      });
    } else {
      form.resetFields();
    }
  }, [open, project, form]);

  const handleSubmit = async (values) => {
    if (!project?.pjtId) return;
    setLoading(true);
    try {
      const payload = {
        ...values,
        pjtBgngYmd: values.pjtBgngYmd ? values.pjtBgngYmd.format('YYYY-MM-DD') : undefined,
        pjtEndYmd: values.pjtEndYmd ? values.pjtEndYmd.format('YYYY-MM-DD') : undefined,
        pjtOpnDt: values.pjtOpnDt ? values.pjtOpnDt.format('YYYY-MM-DDTHH:mm:ss') : undefined,
      };
      await updateProject(project.pjtId, payload);
      onSuccess();
    } catch (error) {
      console.error('프로젝트 수정 실패:', error);
      // 에러 토스트는 공통 인터셉터에서 처리
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="프로젝트 수정"
      open={open}
      onCancel={handleCancel}
      onOk={() => form.submit()}
      confirmLoading={loading}
      width={600}
      okText="수정"
      cancelText="취소"
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Form.Item
          label="프로젝트명"
          name="pjtNm"
          rules={[
            { required: true, message: '프로젝트명을 입력해주세요.' },
            { max: 100, message: '프로젝트명은 100자 이내로 입력해주세요.' }
          ]}
        >
          <Input placeholder="프로젝트명을 입력하세요" />
        </Form.Item>

        <Form.Item label="프로젝트 번호" name="pjtNo" rules={[{ required: true, message: '프로젝트 번호를 입력하세요.' }]}>
          <Input placeholder="프로젝트 번호를 입력하세요" />
        </Form.Item>

        <Form.Item label="담당자명" name="pjtPicNm">
          <Input placeholder="담당자명을 입력하세요" />
        </Form.Item>

        <Form.Item label="시작일자" name="pjtBgngYmd">
          <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" placeholder="예: 2025-01-01" />
        </Form.Item>

        <Form.Item label="종료일자" name="pjtEndYmd">
          <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" placeholder="예: 2025-12-31" />
        </Form.Item>

        <Form.Item label="개방일시" name="pjtOpnDt">
          <DatePicker showTime style={{ width: '100%' }} format="YYYY-MM-DD HH:mm:ss" placeholder="예: 2025-01-01 12:00:00" />
        </Form.Item>

        <Form.Item
          label="프로젝트 정보"
          name="pjtInfo"
          rules={[{ max: 500, message: '프로젝트 정보는 500자 이내로 입력해주세요.' }]}
        >
          <TextArea rows={4} placeholder="프로젝트에 대한 정보를 입력하세요" showCount maxLength={500} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ProjectEditModal;
